export default "__VITE_PUBLIC_ASSET__6360542d__"